import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "filuet-integration",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#filuet-integration",
        "aria-label": "filuet integration permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Filuet Integration`}</h1>
    <p>{`Filuet Integration is a service designed for integration with Filuet - provider of trading and logistics services.`}<br parentName="p"></br>{`
`}{`More details you can find in the confluence `}<a parentName="p" {...{
        "href": "https://younglivingeo.atlassian.net/wiki/spaces/TEAM6/pages/348258531/Filuet+Integration+API"
      }}>{`Filuet Integration API`}</a></p>
    <h1 {...{
      "id": "usage",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#usage",
        "aria-label": "usage permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Usage`}</h1>
    <p>{`Filuet 1C system getting necessary data from YL using FiluetIntegration endpoint.`}</p>
    <h1 {...{
      "id": "development-and-testing",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#development-and-testing",
        "aria-label": "development and testing permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Development and Testing`}</h1>
    <h4 {...{
      "id": "the-main-language-of-the-application",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#the-main-language-of-the-application",
        "aria-label": "the main language of the application permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`The main language of the application?`}</h4>
    <p>{`Main language of this service is C#`}</p>
    <h4 {...{
      "id": "what-libraries-and-modules-does-it-require",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#what-libraries-and-modules-does-it-require",
        "aria-label": "what libraries and modules does it require permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`What libraries and modules does it require?`}</h4>
    <h4 {...{
      "id": "what-should-a-new-developer-and-sre-resource-need-to-know-about-this-application",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#what-should-a-new-developer-and-sre-resource-need-to-know-about-this-application",
        "aria-label": "what should a new developer and sre resource need to know about this application permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`What should a new developer and SRE resource need to know about this application?`}</h4>
    <p>{` A push/merge to master will automatically deploy to the `}<strong parentName="p">{`Prod`}</strong>{` environment.`}<br parentName="p"></br>{`
`}{`A push/merge to develop will automatically deploy to the `}<strong parentName="p">{`Dev`}</strong>{` environment.`}</p>
    <p>{` A creation of a pull-request from a branch prefixed with `}<strong parentName="p">{`release/`}</strong>{` will
automatically trigger a build. To deploy to the `}<strong parentName="p">{`Stage`}</strong>{` environment, you need
to click the "Run" button on the BitBucket pipeline containing your build.`}</p>
    <p>{` A push to any branch other than master and develop will trigger a build. To`}<br parentName="p"></br>{`
`}{`deploy to the `}<strong parentName="p">{`Test`}</strong>{` environment, you need to click the "Run" button`}<br parentName="p"></br>{`
`}{`on the BitBucket pipeline containing your build.`}</p>
    <h2 {...{
      "id": "testing",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#testing",
        "aria-label": "testing permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Testing`}</h2>
    <ul>
      <li parentName="ul">{`How is this application tested?
There is a Yleo.FiluetIntegration.Specs project that contains tests and they run on every build.`}</li>
      <li parentName="ul">{`What tests are available?
There are unit and integration tests for this project.`}</li>
      <li parentName="ul">{`How can the tests be manually executed?
You can run tests from VS. To have an ablity manually call endpoint on test environment you should claim an access token first.`}</li>
    </ul>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "shell"
    }}><pre parentName="div" {...{
        "style": {
          "counterReset": "linenumber NaN"
        },
        "className": "language-shell line-numbers"
      }}><code parentName="pre" {...{
          "className": "language-shell"
        }}><span parentName="code" {...{
            "className": "command-line-prompt"
          }}><span parentName="span" {...{
              "data-user": "root",
              "data-host": "localhost"
            }}></span><span parentName="span" {...{
              "data-user": "root",
              "data-host": "localhost"
            }}></span><span parentName="span" {...{
              "data-user": "root",
              "data-host": "localhost"
            }}></span></span><span parentName="code" {...{
            "className": "token function"
          }}>{`curl`}</span>{` -sS -X POST `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"https://auth-stage.youngliving.com/connect/token"`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`\\`}</span>{`
  -H `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Content-Type: application/x-www-form-urlencoded'`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`\\`}</span>{`
  -d `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'grant_type=client_credentials&client_id=<non-prod-client>&client_secret=<non-prod-secret>&scope=filuet'`}</span></code><span parentName="pre" {...{
          "aria-hidden": "true",
          "className": "line-numbers-rows",
          "style": {
            "whiteSpace": "normal",
            "width": "auto",
            "left": "0"
          }
        }}><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span></span></pre></div>
    <p>{`After that you should use provided token within your request to a service`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "shell"
    }}><pre parentName="div" {...{
        "style": {
          "counterReset": "linenumber NaN"
        },
        "className": "language-shell line-numbers"
      }}><code parentName="pre" {...{
          "className": "language-shell"
        }}><span parentName="code" {...{
            "className": "command-line-prompt"
          }}><span parentName="span" {...{
              "data-user": "root",
              "data-host": "localhost"
            }}></span><span parentName="span" {...{
              "data-user": "root",
              "data-host": "localhost"
            }}></span></span><span parentName="code" {...{
            "className": "token function"
          }}>{`curl`}</span>{` --location --request GET `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'https://filuet-stage.youngliving.com/api/v1/customers/<customerid>'`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`\\`}</span>{`
--header `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Authorization: Bearer <provided_token>'`}</span></code><span parentName="pre" {...{
          "aria-hidden": "true",
          "className": "line-numbers-rows",
          "style": {
            "whiteSpace": "normal",
            "width": "auto",
            "left": "0"
          }
        }}><span parentName="span"></span><span parentName="span"></span></span></pre></div>
    <h2 {...{
      "id": "building",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#building",
        "aria-label": "building permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Building`}</h2>
    <p>{`How to build it localy you can find in the `}<a parentName="p" {...{
        "href": "https://bitbucket.org/youngliving/filuet-integration/src/develop/Yleo.FiluetIntegration.Web/Dockerfile"
      }}>{`Yleo.FiluetIntegration.Web/Dockerfile`}</a></p>
    <p>{`To build docker image use next example:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "style": {
          "counterReset": "linenumber NaN"
        },
        "className": "language-text line-numbers"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`docker build \\
    -f Yleo.FiluetIntegration.Web/Dockerfile \\
    -t $IMAGE_NAME \\
    --build-arg version=$VERSION \\
    --target 'release-build' \\
    --no-cache \\
    --pull \\
    .`}</code><span parentName="pre" {...{
          "aria-hidden": "true",
          "className": "line-numbers-rows",
          "style": {
            "whiteSpace": "normal",
            "width": "auto",
            "left": "0"
          }
        }}><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span></span></pre></div>
    <h2 {...{
      "id": "databases",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#databases",
        "aria-label": "databases permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Databases`}</h2>
    <ul>
      <li parentName="ul">{`database used: vo_accounts`}</li>
    </ul>
    <h2 {...{
      "id": "infrastructure",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#infrastructure",
        "aria-label": "infrastructure permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Infrastructure`}</h2>
    <p>{`This service in the AWS.`}</p>
    <p>{`The following are the origins used by the API Gateway. These are not
used by Filuet directly, but are accessible internally.`}</p>
    <ul>
      <li parentName="ul">{`Dev - `}<a parentName="li" {...{
          "href": "https://filuet-integration-dev.awsvodev.youngliving.com"
        }}>{`https://filuet-integration-dev.awsvodev.youngliving.com`}</a></li>
      <li parentName="ul">{`Stage - `}<a parentName="li" {...{
          "href": "https://filuet-integration-stage.awsvodev.youngliving.com"
        }}>{`https://filuet-integration-stage.awsvodev.youngliving.com`}</a></li>
      <li parentName="ul">{`Test - `}<a parentName="li" {...{
          "href": "https://filuet-integration-test.awsvodev.youngliving.com"
        }}>{`https://filuet-integration-test.awsvodev.youngliving.com`}</a></li>
      <li parentName="ul">{`Prod - `}<a parentName="li" {...{
          "href": "https://filuet-integration.awsvoprd.youngliving.com"
        }}>{`https://filuet-integration.awsvoprd.youngliving.com`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      